import axios from 'axios'

// 调用 axios.create() 方法，创建 axios 的实例对象
const instance = axios.create({
  // 请求根路径
  baseURL: 'http://www.mba001.com:8080/tang/'
  // baseURL: 'http://192.168.132.1:8083/'
})

export default instance
